import React from 'react';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { usePayPal } from '../../contexts/PayPalContext';

interface PayPalCheckoutProps {
  amount: number;
  productType: string;
  onSuccess: (orderId: string) => void;
  onError: (error: string) => void;
}

const PayPalCheckout: React.FC<PayPalCheckoutProps> = ({
  amount,
  productType,
  onSuccess,
  onError
}) => {
  const { clientId } = usePayPal();

  const initialOptions = {
    clientId: clientId,
    currency: 'USD',
    intent: 'capture'
  };

  return (
    <div className="bg-white/10 backdrop-blur-md rounded-lg p-4">
      <h3 className="text-white font-semibold mb-4">Complete Payment with PayPal</h3>

      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          style={{
            layout: 'vertical',
            color: 'gold',
            shape: 'rect',
            label: 'paypal'
          }}
          createOrder={(data, actions) => {
            return actions.order.create({
              intent: 'CAPTURE',
              purchase_units: [
                {
                  amount: {
                    currency_code: 'USD',
                    value: amount.toFixed(2),
                  },
                  description: productType
                }
              ]
            });
          }}
          onApprove={async (data, actions) => {
            try {
              if (actions.order) {
                const details = await actions.order.capture();
                onSuccess(details.id || '');
              }
            } catch (error) {
              onError('Payment approval failed');
            }
          }}
          onError={(err) => {
            onError('PayPal checkout error');
          }}
          onCancel={() => {
            onError('Payment cancelled');
          }}
        />
      </PayPalScriptProvider>
    </div>
  );
};

export default PayPalCheckout;
